import React from "react";

export const StyleItalic = (props: React.PropsWithChildren<{}>): JSX.Element => {
    return (
        <span style={{ fontStyle: "italic" }}>
            {props.children}
        </span>
    );
};
